<template>
    <div class="mb-3">
        <div class="property-input property-item form-group row align-items-center">
            <label class="col-lg-3 col-form-label" :for="'ORDER_PROP_' + phoneProperty.ID">
                <span>{{phoneProperty['NAME']}}</span><span
                                                            class="color-dark-red">*</span>
            </label>
<!--          <label class="col-lg-3 col-form-label" :for="'ORDER_PROP_' + phoneProperty.ID">
                       <span>{{phoneProperty['NAME']}}</span><span v-if="phoneProperty['REQUIRED']==='Y'"
                                                                   class="color-dark-red">*</span>
                   </label>-->
            <div class="col-lg-6">
                <masked-input class="form-control"
                              :name="'ORDER_PROP_' + phoneProperty.ID"
                              :id="'ORDER_PROP_' + phoneProperty.ID"
                              :required="phoneProperty['REQUIRED'] === 'Y'"
                              :value="phoneValue"
                              mask="+7 (999) 999 99 99" placeholder="+7 (___) ___ __ __"
                              :parameters="{clearIncomplete: true}"
                              type="tel"
                              @input="phoneInput"
                              @update:isComplete="phoneComplete"
                              ref="maskedPhone"
                />
            </div>
            <div class="col mt-3 mt-lg-0">
                <div v-if="isPhoneSuccess" class="text-center">
                    <span class="color-light-green"><i class="fa fa-check" aria-hidden="true"></i> Подтвержден</span>
                </div>
                <div v-if="!isPhoneSuccess">
                    <button v-if="codeTimer > 0" disabled="disabled" type="button" class="btn btn-primary w-100"><span>{{codeTimer}}</span>
                    </button>
                    <button v-if="!(codeTimer > 0)" @click="sendCode" type="button" class="btn btn-primary w-100"><span>ОТПРАВИТЬ</span>
                    </button>
                </div>
            </div>
        </div>
        <div v-if="!isPhoneSuccess">
            <div class="row">
                <div class="col-lg-9 ml-auto">
                    <div v-if="error === '' && info === ''">
                        <p class="color-grey">Мы отправим на ваш номер SMS-сообщение, содержащее
                            проверочный код. Введите полученный
                            код в соответствующее поле и нажмите кнопку подтвердить</p>
                    </div>
                    <div v-if="error" class="alert alert-danger" role="alert">
                        <p  v-html="error"></p>
                    </div>
                    <div v-if="info" class="alert alert-primary" role="alert">
                        <p v-html="error"></p>
                    </div>
                </div>
            </div>
            <div class="property-input property-item form-group row align-items-center">
                <label class="col-lg-3 col-form-label" :for="'ORDER_PROP_' + phoneProperty.ID">
                    <span>Код из смс</span><span class="color-dark-red">*</span>
                </label>
                <div class="col-lg-6">
                    <masked-input class="form-control"
                                  :name="'ORDER_PROP_' + phoneProperty.ID + '_CODE'"
                                  :id="'ORDER_PROP_' + phoneProperty.ID + '_CODE'"
                                  :required="phoneProperty['REQUIRED'] === 'Y'"
                                  :value="code"
                                  mask="9999" placeholder="____"
                                  :parameters="{clearIncomplete: true}"
                                  @input="codeInput"
                                  @update:isComplete="codeComplete"
                    />
                </div>
                <div class="col mt-3 mt-lg-0">
                    <div v-if="isPhoneSuccess" class="text-center">
                        <span class="color-light-green"><i class="fa fa-check" aria-hidden="true"></i>Подтвержден</span>
                    </div>
                    <div v-if="!isPhoneSuccess">
                        <button @click="checkCode" type="button" class="btn btn-primary w-100"><span>ПОДТВЕРДИТЬ</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-9 ml-auto">
                    <div>
                        <button :disabled="codeTimer > 0" @click="sendCode" type="button"
                                class="btn btn-clear color-grey">Получить
                            новый
                            <span class="text-under-line">код подтверждения</span> <span v-if="codeTimer > 0">({{codeTimer}})</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import MaskedInput from '../../MaskedInput'
  import _ from 'lodash'

  export default {
    name: 'property-phone-input',
    components: {MaskedInput},
    props: {
      phoneProperty: {
        type: Object,
        required: true
      }, // свойство телефона
      phoneValue: {
        type: String,
        default: ''
      }, // телефон
      isPhoneSuccessValue: {
        type: Boolean,
        default: false
      } // телефон подтвержден
    },
    data () {
      return {
        code: '', // код из смс
        phone: '', // телефон
        isCodeCorrect: false, // код введен
        isCodeSend: false, // код отправлен
        isPhoneCorrect: false, // телефон введен
        phoneSuccess: this.phoneValue,
        error: '',
        info: '',
        codeTimer: 0
      }
    },
    created () {
      if (this.isPhoneSuccess) {
        this.phoneSuccess = this.phoneValue
      }

      /** THIS IS BUG!!! */
      setInterval(() => {
        if (this.$refs.maskedPhone) {
          let element = this.$refs.maskedPhone.$el
          this.triggerEvent(element, 'input')
        }
      }, 50)
    },
    computed: {
      isPhoneSuccess: {
        get: function () {
          return this.isPhoneSuccessValue
        },
        set: function (isSuccess) {
          if (isSuccess) {
            console.log('111', this.phone)
            this.phoneSuccess = this.phone
          }
          this.$emit('update:isPhoneSuccess', isSuccess)
        }
      }
    },
    watch: {
      phone (newValue, oldValue) {
        this.$emit('input:phone', newValue, oldValue)
      },
      code (newValue, oldValue) {
        let element = this.$refs.maskedPhone.$el
        this.triggerEvent(element, 'input')

        this.$emit('input:code', newValue, oldValue)
      },
      phoneValue (newValue, oldValue) {
        let element = this.$refs.maskedPhone.$el
        this.triggerEvent(element, 'input')

        console.log('phone change', newValue, oldValue)
      },
      isPhoneSuccessValue (newValue, oldValue) {
        let element = this.$refs.maskedPhone.$el
        this.triggerEvent(element, 'input')

        console.log('updated', newValue, oldValue)
      }
    },
    methods: {
      showRef: function ($event) {
        $event.preventDefault()

        let element = this.$refs.maskedPhone.$el

        this.triggerEvent(element, 'input')
      },
      triggerEvent (el, type) {
        let e
        if ('createEvent' in document) {
          // modern browsers, IE9+
          e = document.createEvent('HTMLEvents')
          e.initEvent(type, false, true)
          el.dispatchEvent(e)
        } else {
          // IE 8
          e = document.createEventObject()
          e.eventType = type
          el.fireEvent('on' + e.eventType, e)
        }
      },
      phoneInput (value) {
        if (value !== '') {
          this.phone = value.replace(/[^0-9.]/g, '').substr(1)
        } else {
          this.phone = value
        }
      },
      phoneComplete (isCorrect) {
        this.isPhoneCorrect = isCorrect
        if (isCorrect) {
          this.cleanError()
          this.isPhoneSuccess = this.phone === this.phoneSuccess
         // this.isPhoneCorrect = true;
        } else {
          this.isPhoneSuccess = false
        }
         this.isPhoneCorrect = this.phoneValue.length === 10
      },
      sendCode () {
        this.cleanError()
        this.isCodeSend = false

        let element = this.$refs.maskedPhone.$el

        this.triggerEvent(element, 'input')

        if (this.isPhoneSuccess) {
          return
        }

        if (!this.isPhoneCorrect) {
        //  this.showError('Номер введен не корректно')
       //   return
        }

        if (this.codeTimer > 0) {
          return
        }
        this.codeTimer = 0

        let params = new FormData()
        params.append('phone', this.phone)
        params.append('type', 'order')
        params.append('is_exists', 1)
        let vm = this
        this.$http.post('/ajax_new/Code/send/', params).then(request => {
          if (request.data.status) {
            vm.isCodeSend = true
            vm.setTimer(5)
          } else {
            vm.showError(_.first(request.data.errors).message)
          }
        }).catch(error => {
          this.showError(error)
          console.error(error)
        })
      },
      codeInput (value) {
        if (value !== '') {
          this.code = value.replace(/[^0-9.]/g, '')
        } else {
          this.code = value
        }
      },
      codeComplete (isCorrect) {
        this.isCodeCorrect = isCorrect
      },
      setTimer (time) {
        this.codeTimer = time
        window.setInterval(() => {
          if (this.codeTimer > 0) {
            this.codeTimer--
          }
        }, 1000)
      },
      checkCode () {
        this.cleanError()

        if (this.isPhoneSuccess) {
          return
        }
        if (!this.isPhoneCorrect) {
        /*  this.showError('Номер введен не корректно')
          return*/
        }
        if (!this.isCodeCorrect) {
        /*  this.showError('Код введен не корректно')
          return*/
        }

        let params = new FormData()
        params.append('phone', this.phone)
        params.append('code', this.code)
        params.append('type', 'order')

        this.$http.post('/ajax_new/Code/check/', params).then(request => {
          if (request.data.status) {
            this.isPhoneSuccess = true
          } else {
            this.showError(_.first(request.data.errors).message)
          }
        }).catch(error => {
          this.showError(error)
          console.error(error)
        })
      },
      showError (message) {
        this.error = message
      },
      cleanError () {
        this.error = ''
      },
      showInfoModal (message) {
        this.info = message
      },
      cleanInfo () {
        this.info = ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/components/order/components/PropertyPhoneInput.vue